import type { ExportData } from '../types';

const prepareIntermediaryDownloadFormDataObject = ({
    action,
    project_id,
    debug,
    branch,
    config,
}: ExportData): Record<string, string> => {
    const intermediaryConfigObject: Record<string, string> = {
        action,
        project_id,
        debug: `${debug}`,
        branch: branch ?? '',
    };

    Object.entries(config).forEach(([key, value]) => {
        if (typeof value === 'undefined') {
            return;
        }

        if (typeof value === 'boolean') {
            intermediaryConfigObject[`config[${key}]`] = JSON.stringify(value);

            return;
        }

        if (['string', 'number'].includes(typeof value)) {
            intermediaryConfigObject[`config[${key}]`] = `${value}`;

            return;
        }

        if (Array.isArray(value)) {
            intermediaryConfigObject[`config[${key}]`] = value.join();

            return;
        }

        if (key === 'indentation') {
            const [fileFormat, indentation] = Object.entries(value)[0];

            intermediaryConfigObject[`config[${key}][${fileFormat}]`] = `${indentation}`;

            return;
        }

        if (key === 'replaceLineBreaks') {
            const replaceLineBreaksEntries = Object.entries(value);

            if (!replaceLineBreaksEntries.length) {
                intermediaryConfigObject[`config[${key}][${config.file_format}]`] = 'false';

                return;
            }

            replaceLineBreaksEntries.forEach(([format, isReplaceEnabled]) => {
                intermediaryConfigObject[`config[${key}][${format}]`] = `${isReplaceEnabled}`;
            });
        }

        if (key === 'customIsoCodes') {
            const customIsoCodesEntries = Object.entries(value);

            if (!customIsoCodesEntries.length) {
                return;
            }

            customIsoCodesEntries.forEach(([format, codes]) => {
                Object.entries(codes).forEach(([languageId, code]) => {
                    if (typeof code === 'string' || typeof code === 'number') {
                        intermediaryConfigObject[`config[${key}][${format}][${languageId}]`] = `${code}`;
                    }
                });
            });
        }
    });

    return intermediaryConfigObject;
};

export default prepareIntermediaryDownloadFormDataObject;
